import { __assign, __read, __spreadArray, __values } from "tslib";
import { default as Calendar } from "./Calendar";
import { default as InputValueMapper } from "./InputValueMapper";
import { default as Products } from "./Products";
import { ProductQueryParam, ProductTypeHelper, store, } from 'ltur-state-engine';
var UrlMapper = /** @class */ (function () {
    function UrlMapper() {
    }
    UrlMapper.mapDestinationConfirmedValue = function (searchMaskGroupType, defaultInputValue, productQuery, productGroupId) {
        var state = store.getState();
        var coreStateGroup = ProductTypeHelper.mapSearchMaskGroupTypeToCoreStateGroup(searchMaskGroupType);
        var formData = state.coreState[coreStateGroup].formData;
        if (productGroupId && formData.flatProductGroups[productGroupId]) {
            return Products.createDestinationInputValue(formData.flatProductGroups[productGroupId]);
        }
        if (productQuery['PRODUCT_GROUPS'] !== void 0
            && productQuery['PRODUCT_GROUPS'][0] !== void 0
            && formData.flatProductGroups[productQuery['PRODUCT_GROUPS'][0]]) {
            return Products.createDestinationInputValue(formData.flatProductGroups[productQuery['PRODUCT_GROUPS'][0]]);
        }
        return defaultInputValue;
    };
    UrlMapper.mapHotelCategoryConfirmedValue = function (defaultInputValue, productQuery) {
        if (productQuery[ProductQueryParam.HOTEL_CATEGORY] !== void 0) {
            var value = productQuery[ProductQueryParam.HOTEL_CATEGORY];
            var selectedIndex = defaultInputValue.uiValue.options.map(function (e) { return e.value; }).map(function (e) { return Array.isArray(e) ? e[0] : e; }).indexOf(Array.isArray(value) ? value[0] : value);
            if (selectedIndex == -1 || selectedIndex == null || typeof selectedIndex == 'undefined') {
                selectedIndex = 0;
            }
            var inputValue = __assign(__assign({}, defaultInputValue), { value: value });
            inputValue.uiValue.text = defaultInputValue.uiValue.options[selectedIndex].name;
            return inputValue;
        }
        return defaultInputValue;
    };
    UrlMapper.mapDestinationCoreQuery = function (productQuery) {
        var _a;
        if (productQuery['PRODUCT_GROUPS'] !== void 0 && productQuery['PRODUCT_GROUPS'][0] !== void 0) {
            return _a = {}, _a[ProductQueryParam.PRODUCT_GROUPS] = [productQuery['PRODUCT_GROUPS'][0]], _a;
        }
        return null;
    };
    UrlMapper.mapDepartureAirport = function (airportGroupList, confirmedValue, searchMaskGroupType, productQuery) {
        var e_1, _a, e_2, _b, e_3, _c;
        var inputValue = {
            uiValue: confirmedValue.uiValue,
            value: confirmedValue.value
        };
        if (productQuery['FLIGHT_DEPARTURE_AIRPORT_GROUPS'] !== void 0) {
            try {
                for (var _d = __values(productQuery['FLIGHT_DEPARTURE_AIRPORT_GROUPS']), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var airportGroupId = _e.value;
                    var selectedIndex = airportGroupList.map(function (e) { return e.id; }).indexOf(airportGroupId);
                    if (selectedIndex >= 0) {
                        InputValueMapper.uniqueDepartureAirport(inputValue.value, airportGroupList[selectedIndex], true);
                        InputValueMapper.groupSingleHandlingDepartureAirport(inputValue, airportGroupList[selectedIndex], airportGroupList);
                        InputValueMapper.departureAirportUIValue(inputValue, airportGroupList, searchMaskGroupType);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (productQuery['FLIGHT_DEPARTURE_AIRPORT_CODES'] !== void 0) {
            try {
                for (var _f = __values(productQuery['FLIGHT_DEPARTURE_AIRPORT_CODES']), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var airportCode = _g.value;
                    try {
                        for (var airportGroupList_1 = (e_3 = void 0, __values(airportGroupList)), airportGroupList_1_1 = airportGroupList_1.next(); !airportGroupList_1_1.done; airportGroupList_1_1 = airportGroupList_1.next()) {
                            var airportGroup = airportGroupList_1_1.value;
                            var selectedIndex = airportGroup.airports.map(function (e) { return e.code; }).indexOf(airportCode);
                            if (selectedIndex >= 0) {
                                InputValueMapper.uniqueDepartureAirport(inputValue.value, airportGroup.airports[selectedIndex], true);
                                InputValueMapper.groupSingleHandlingDepartureAirport(inputValue, airportGroup.airports[selectedIndex], airportGroupList);
                                InputValueMapper.departureAirportUIValue(inputValue, airportGroupList, searchMaskGroupType);
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (airportGroupList_1_1 && !airportGroupList_1_1.done && (_c = airportGroupList_1.return)) _c.call(airportGroupList_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return inputValue;
    };
    UrlMapper.mapTransferConfirmedValue = function (defaultInputValue, productQuery) {
        if (productQuery[ProductQueryParam.EXTRAS] !== void 0 && productQuery[ProductQueryParam.EXTRAS][0] !== void 0) {
            var value = productQuery[ProductQueryParam.EXTRAS].includes('TR');
            return __assign(__assign({}, defaultInputValue), { value: value });
        }
        return defaultInputValue;
    };
    UrlMapper.mapTrainToFlightConfirmedValue = function (defaultInputValue, productQuery) {
        if (productQuery[ProductQueryParam.EXTRAS] !== void 0 && productQuery[ProductQueryParam.EXTRAS][0] !== void 0) {
            var value = productQuery[ProductQueryParam.EXTRAS].includes('RAIL_AND_FLY');
            return __assign(__assign({}, defaultInputValue), { value: value });
        }
        return defaultInputValue;
    };
    UrlMapper.mapFlexConfirmedValue = function (defaultInputValue, queryObject) {
        if (queryObject['flex']) {
            return __assign(__assign({}, defaultInputValue), { value: true });
        }
        return defaultInputValue;
    };
    UrlMapper.mapHotelBoardCodeConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(1400, false, defaultInputValue, productQuery);
        ;
    };
    UrlMapper.mapHotelRoomCodeConfirmedValue = function (defaultInputValue, productQuery) {
        var roomCodeConfirmedValue = UrlMapper.mapOptionsConfirmedValue(1300, false, defaultInputValue, productQuery);
        //var roomCharacteristicsConfirmedValue =  UrlMapper.mapOptionsConfirmedValue(2300,true, defaultInputValue, productQuery);
        var dynamicRoomCodeConfirmedValue = UrlMapper.mapOptionsConfirmedValue(12000, false, defaultInputValue, productQuery);
        //var dynamicRoomAttributeCodeConfirmedValue =  UrlMapper.mapOptionsConfirmedValue(12100,true, defaultInputValue, productQuery);
        var confirmedValue = [];
        var roomCode = roomCodeConfirmedValue.value;
        //const roomCharacteristicsCodes = roomCharacteristicsConfirmedValue.value;
        var dynamicRoomCode = dynamicRoomCodeConfirmedValue.value;
        //const dynamicRoomAttributeCode = dynamicRoomAttributeCodeConfirmedValue.value;
        if (dynamicRoomCode) {
            confirmedValue.push(dynamicRoomCode);
        }
        /*  if(dynamicRoomAttributeCode){
              confirmedValue.push(...dynamicRoomAttributeCode);
          }
          if(roomCharacteristicsCodes){
              confirmedValue.push(...roomCharacteristicsCodes);
          }*/
        if (roomCode) {
            confirmedValue.push(roomCode);
        }
        if (confirmedValue.length == 0) {
            confirmedValue = null;
        }
        roomCodeConfirmedValue.value = confirmedValue;
        return roomCodeConfirmedValue;
    };
    UrlMapper.mapHotelRecommendationsConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(1800, false, defaultInputValue, productQuery);
    };
    UrlMapper.mapHotelRatingConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(1900, false, defaultInputValue, productQuery);
    };
    UrlMapper.mapLocationConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(1100, false, defaultInputValue, productQuery);
    };
    UrlMapper.mapFeaturesConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(1600, true, defaultInputValue, productQuery);
    };
    UrlMapper.mapTargetGroupsConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(1500, true, defaultInputValue, productQuery);
    };
    UrlMapper.mapSportsConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(1700, true, defaultInputValue, productQuery);
    };
    UrlMapper.mapAccommodationTypeCodeConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(2200, false, defaultInputValue, productQuery);
    };
    UrlMapper.mapWintersportsConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(2600, true, defaultInputValue, productQuery);
    };
    UrlMapper.mapWellnessConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(2400, true, defaultInputValue, productQuery);
    };
    UrlMapper.mapFamilyConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(2500, true, defaultInputValue, productQuery);
    };
    UrlMapper.mapRoomCharacteristicsConfirmedValue = function (defaultInputValue, productQuery) {
        var roomCharacteristicsConfirmedValue = UrlMapper.mapOptionsConfirmedValue(2300, true, defaultInputValue, productQuery);
        var dynamicRoomAttributeCodeConfirmedValue = UrlMapper.mapOptionsConfirmedValue(12100, true, defaultInputValue, productQuery);
        var confirmedValue = [];
        var roomCharacteristicsCodes = roomCharacteristicsConfirmedValue.value;
        var dynamicRoomAttributeCode = dynamicRoomAttributeCodeConfirmedValue.value;
        if (dynamicRoomAttributeCode) {
            confirmedValue.push.apply(confirmedValue, __spreadArray([], __read(dynamicRoomAttributeCode), false));
        }
        if (roomCharacteristicsCodes) {
            confirmedValue.push.apply(confirmedValue, __spreadArray([], __read(roomCharacteristicsCodes), false));
        }
        if (confirmedValue.length == 0) {
            confirmedValue = null;
        }
        roomCharacteristicsConfirmedValue.value = confirmedValue;
        return roomCharacteristicsConfirmedValue;
    };
    UrlMapper.mapDealsConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(2000, true, defaultInputValue, productQuery);
    };
    UrlMapper.mapTravelThemesConfirmedValue = function (defaultInputValue, productQuery) {
        return UrlMapper.mapOptionsConfirmedValue(2100, true, defaultInputValue, productQuery);
    };
    UrlMapper.mapOtherCodesConfirmedValue = function (defaultInputValue, productQuery) {
        var confirmedInputValue = JSON.parse(JSON.stringify(defaultInputValue));
        if (productQuery['FLIGHT_AIRLINE_CODES'] && productQuery['FLIGHT_AIRLINE_CODES'].length > 0) {
            confirmedInputValue.value.airlineCodes = productQuery['FLIGHT_AIRLINE_CODES'];
        }
        if (productQuery['HOTEL_ROOM_VIEW_CODES'] && productQuery['HOTEL_ROOM_VIEW_CODES'].length > 0) {
            confirmedInputValue.value.roomViewCodes = productQuery['HOTEL_ROOM_VIEW_CODES'];
        }
        if (productQuery['TOUR_OPERATOR_CODES'] && productQuery['TOUR_OPERATOR_CODES'].length > 0) {
            confirmedInputValue.value.tourOperatorCodes = productQuery['TOUR_OPERATOR_CODES'];
        }
        return confirmedInputValue;
    };
    UrlMapper.mapFlightDepartureTimeRangeConfirmedValue = function (defaultInputValue, productQuery) {
        if (productQuery[ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MIN] && productQuery[ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MAX]) {
            var value = [productQuery[ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MIN], productQuery[ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MAX]];
            return __assign(__assign({}, defaultInputValue), { value: value });
        }
        return defaultInputValue;
    };
    UrlMapper.mapFlightReturnTimeRangeConfirmedValue = function (defaultInputValue, productQuery) {
        if (productQuery[ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MIN] && productQuery[ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MAX]) {
            var value = [productQuery[ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MIN], productQuery[ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MAX]];
            return __assign(__assign({}, defaultInputValue), { value: value });
        }
        return defaultInputValue;
    };
    UrlMapper.mapFlightStopOverMaxConfirmedValue = function (defaultInputValue, productQuery) {
        if (productQuery[ProductQueryParam.FLIGHT_STOP_OVER_MAX] !== void 0) {
            var value = productQuery[ProductQueryParam.FLIGHT_STOP_OVER_MAX];
            return __assign(__assign({}, defaultInputValue), { value: value });
        }
        return defaultInputValue;
    };
    UrlMapper.mapFlightIgnoreOpenJawConfirmedValue = function (defaultInputValue, options) {
        if (options && options["PHUB_FLIGHT_IGNORE_OPEN_JAW"]) {
            var value = options["PHUB_FLIGHT_IGNORE_OPEN_JAW"];
            return __assign(__assign({}, defaultInputValue), { value: value });
        }
        return defaultInputValue;
    };
    UrlMapper.mapPriceRangeConfirmedValue = function (defaultInputValue, productQuery) {
        if (productQuery[ProductQueryParam.PRICE_MIN] !== void 0 || productQuery[ProductQueryParam.PRICE_MAX]) {
            var priceMinVal = productQuery[ProductQueryParam.PRICE_MIN] ? productQuery[ProductQueryParam.PRICE_MIN] : null;
            var priceMaxVal = productQuery[ProductQueryParam.PRICE_MAX] ? productQuery[ProductQueryParam.PRICE_MAX] : null;
            return __assign(__assign({}, defaultInputValue), { value: __assign(__assign({}, defaultInputValue.value), { priceMin: priceMinVal, priceMax: priceMaxVal }) });
        }
        return defaultInputValue;
    };
    UrlMapper.mapOptionsConfirmedValue = function (optionGroupId, multiValue, defaultInputValue, productQuery) {
        if (multiValue === void 0) { multiValue = false; }
        defaultInputValue = JSON.parse(JSON.stringify(defaultInputValue));
        var value;
        if (multiValue) {
            value = UrlMapper.getValuesForOptionGroup(productQuery, optionGroupId);
        }
        else {
            value = UrlMapper.getValueForOptionGroup(productQuery, optionGroupId);
        }
        if (value) {
            var inputValue = __assign(__assign({}, defaultInputValue), { value: value });
            if (defaultInputValue.uiValue !== void 0
                && defaultInputValue.uiValue !== null
                && defaultInputValue.uiValue.options !== void 0
                && defaultInputValue.uiValue.options !== null) {
                var selectedIndex = defaultInputValue.uiValue.options.map(function (e) { return e.value; }).map(function (e) { return Array.isArray(e) ? e[0] : e; }).indexOf(Array.isArray(value) ? value[0] : value);
                if (selectedIndex == -1 || selectedIndex == null || typeof selectedIndex == 'undefined') {
                    selectedIndex = 0;
                }
                inputValue.uiValue.text = defaultInputValue.uiValue.options[selectedIndex].name;
            }
            return inputValue;
        }
        return defaultInputValue;
    };
    UrlMapper.getValueForOptionGroup = function (productQuery, optionGroupId) {
        var value = null;
        var optionGroupPrefix;
        if (optionGroupId.toString().length == 5) {
            optionGroupPrefix = optionGroupId.toString().substring(0, 3);
        }
        else {
            optionGroupPrefix = optionGroupId.toString().substring(0, 2);
        }
        if (productQuery[ProductQueryParam.OPTIONS] !== void 0 && productQuery[ProductQueryParam.OPTIONS].length > 0) {
            var options = productQuery[ProductQueryParam.OPTIONS];
            if (options && Array.isArray(options)) {
                var filteredValue = options.filter(function (option) { return (option && option.toString().startsWith(optionGroupPrefix)); });
                if (Array.isArray(filteredValue)) {
                    value = +(filteredValue[0]);
                }
            }
        }
        return value;
    };
    UrlMapper.getValuesForOptionGroup = function (productQuery, optionGroupId) {
        var value = null;
        var optionGroupPrefix;
        if (optionGroupId.toString().length == 5) {
            optionGroupPrefix = optionGroupId.toString().substring(0, 3);
        }
        else {
            optionGroupPrefix = optionGroupId.toString().substring(0, 2);
        }
        if (productQuery[ProductQueryParam.OPTIONS] !== void 0 && productQuery[ProductQueryParam.OPTIONS].length > 0) {
            var options = productQuery[ProductQueryParam.OPTIONS];
            if (options && Array.isArray(options)) {
                var filteredValue = options.filter(function (option) { return (option && option.toString().startsWith(optionGroupPrefix)); });
                if (Array.isArray(filteredValue) && filteredValue.length == 1) {
                    value = [+(filteredValue[0])];
                }
                else if (Array.isArray(filteredValue) && filteredValue.length > 1) {
                    var optionIds_1 = [];
                    filteredValue.forEach(function (optionId) {
                        optionIds_1.push(+optionId);
                    });
                    value = optionIds_1;
                }
            }
        }
        return value;
    };
    UrlMapper.mapTravelPeriodUIValue = function (formData, travelPeriodUIValue, productQuery) {
        if (productQuery['TRAVEL_PERIOD_DEPARTURE_DATE'] !== void 0
            && productQuery['TRAVEL_PERIOD_RETURN_DATE'] !== void 0) {
            return Calendar.getTravelPeriodUIValue(productQuery['TRAVEL_PERIOD_DEPARTURE_DATE'], productQuery['TRAVEL_PERIOD_RETURN_DATE'], false, false, false);
        }
        if (productQuery['TRAVEL_PERIOD_DEPARTURE_DATE'] !== void 0
            && productQuery['TRAVEL_PERIOD_RETURN_DATE'] === void 0) {
            return Calendar.getTravelPeriodUIValue(productQuery['TRAVEL_PERIOD_DEPARTURE_DATE'], formData.travelPeriod.returnDate.default, false, false, false);
        }
        if (productQuery['TRAVEL_PERIOD_DEPARTURE_DATE'] === void 0
            && productQuery['TRAVEL_PERIOD_RETURN_DATE'] !== void 0) {
            return Calendar.getTravelPeriodUIValue(formData.travelPeriod.departureDate.default, productQuery['TRAVEL_PERIOD_RETURN_DATE'], false, false, false);
        }
        return travelPeriodUIValue;
    };
    UrlMapper.mapTravelPeriodValueDepartureDate = function (departureDate, productQuery) {
        if (productQuery['TRAVEL_PERIOD_DEPARTURE_DATE'] !== void 0) {
            return productQuery['TRAVEL_PERIOD_DEPARTURE_DATE'];
        }
        return departureDate;
    };
    UrlMapper.mapExactDepartureDate = function (exactDepartureDate, productQuery) {
        if (productQuery['TRAVEL_PERIOD_EXACT_DEPARTURE_DATE'] !== void 0) {
            return productQuery['TRAVEL_PERIOD_EXACT_DEPARTURE_DATE'] == 1;
        }
        return exactDepartureDate;
    };
    UrlMapper.mapTravelPeriodValueDepartureDays = function (departureDays, productQuery) {
        if (productQuery['TRAVEL_PERIOD_DEPARTURE_DAYS'] !== void 0 && productQuery['TRAVEL_PERIOD_DEPARTURE_DAYS']) {
            return productQuery['TRAVEL_PERIOD_DEPARTURE_DAYS'];
        }
        return departureDays;
    };
    UrlMapper.mapTravelPeriodValueReturnDate = function (returnDate, productQuery) {
        if (productQuery['TRAVEL_PERIOD_RETURN_DATE'] !== void 0) {
            return productQuery['TRAVEL_PERIOD_RETURN_DATE'];
        }
        return returnDate;
    };
    UrlMapper.mapTravelPeriodUIValueDuration = function (formData, duration, productQuery) {
        if (productQuery['TRAVEL_PERIOD_DURATION'] !== void 0) {
            return Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, productQuery['TRAVEL_PERIOD_DURATION']);
        }
        return duration;
    };
    UrlMapper.mapTravelPeriodValueDuration = function (duration, productQuery) {
        if (productQuery['TRAVEL_PERIOD_DURATION'] !== void 0) {
            return productQuery['TRAVEL_PERIOD_DURATION'];
        }
        return duration;
    };
    UrlMapper.mapTravelPeriodValueExactDuration = function (queryObject, exactDuration) {
        if (queryObject['exactDuration'] !== void 0 && queryObject['exactDuration'] == true) {
            return true;
        }
        return exactDuration;
    };
    UrlMapper.mapTravelPeriodValuePreferredDepartureDate = function (preferredDepartureDate, queryObject) {
        if (queryObject['TRAVEL_PERIOD_PREFERRED_DEPARTURE_DATE'] !== void 0) {
            return queryObject['TRAVEL_PERIOD_PREFERRED_DEPARTURE_DATE'];
        }
        return preferredDepartureDate;
    };
    UrlMapper.mapTravellers = function (travellersInputValue, queryObject) {
        if (queryObject['TRAVELLERS_ADULTS'] !== void 0) {
            travellersInputValue.value.adults = queryObject['TRAVELLERS_ADULTS'];
        }
        if (queryObject['TRAVELLERS_CHILDREN_AGE'] !== void 0) {
            travellersInputValue.value.ageOfChildren = queryObject['TRAVELLERS_CHILDREN_AGE'];
            travellersInputValue.value.childrenNoteShow = true;
            travellersInputValue.value.childrenAgeChoiceShow = true;
            travellersInputValue.value.ageOfChildrenLength = queryObject['TRAVELLERS_CHILDREN_AGE'].length;
        }
        travellersInputValue.uiValue = InputValueMapper.getTravellersUIValue(travellersInputValue.value.adults, travellersInputValue.value.ageOfChildren.length);
        return travellersInputValue;
    };
    UrlMapper.mapPaginationConfirmedValue = function (defaultInputValue, query) {
        if (query) {
            var confirmedValue = JSON.parse(JSON.stringify(defaultInputValue));
            var url = new URL(location.href);
            if (query["page"] !== void 0 && query["page"] != "" && url.searchParams.has('list_back')) {
                confirmedValue.value.page = query["page"];
                url.searchParams.delete('list_back');
                history.replaceState('', '', url.href);
            }
            if (query["sorting"] !== void 0 && query["sorting"] != "") {
                confirmedValue.value.sorting = query["sorting"].split(",");
            }
            return confirmedValue;
        }
        return defaultInputValue;
    };
    return UrlMapper;
}());
export default UrlMapper;
